import React, { useState } from 'react'

import { Box, Grid } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'

import { Container, LoadingFeedback, Page, RoundedBorder } from 'components'
import {
  Header,
  IncidentReportFilters,
  IncidentReportFormat,
  ReportVersionExistsDialog,
  ReportVersionTable,
} from './components'
import { schema } from './components/IncidentReportFormat'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'
import useStyles from './styles'

const IncidentsReports = () => {
  const classes = useStyles()
  const [exporting, setExporting] = useState(false)
  const [refresher, setRefresher] = useState(false)
  const [reportVersionExistsOpen, setReportVersionExistsOpen] = useState(false)
  const [currentReportVersion, setCurrentReportVersion] = useState()

  const formMethods = useForm({
    validationSchema: schema(),
    defaultValues: {
      createdAt: null,
      incidentViolationTypeId: '',
      responsibleUserId: '',
      steps: '',
      tratamentStatus: '',
      simplifiedForm: '',
    },
  })
  const { watch, triggerValidation } = formMethods

  const snackbar = useSnackbar()

  const handleRefresh = () => setRefresher((prev) => !prev)

  const buildExportParams = (shouldCreateVersion) => {
    const { createdAt, ...rest } = watch()

    return {
      ...rest,
      createdAt: createdAt
        ? helpers.formatters.date(createdAt, 'YYYY-MM-DD')
        : undefined,
      shouldCreateVersion,
    }
  }

  const exportReport = async (shouldCreateVersion) => {
    setExporting(true)
    try {
      await service.dponet.incidents.exportReport(
        buildExportParams(shouldCreateVersion),
      )

      snackbar.open({
        message: 'O relatório será gerado e enviado por e-mail!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Houve um erro durante o processamento de dados.',
        ),
        variant: 'error',
      })
    } finally {
      setExporting(false)
      setTimeout(handleRefresh, 8000)
    }
  }

  const buttonAction = async () => {
    const isValid = await triggerValidation()
    if (!isValid) return

    if (!!currentReportVersion?.id) {
      return setReportVersionExistsOpen(true)
    }
    return exportReport(true)
  }

  return (
    <Page className={classes.root} title="Relatório de Incidentes">
      <Box position="relative">
        <RoundedBorder />
        <LoadingFeedback open={exporting} />
      </Box>
      <Container maxWidth={false} spacingXl={15} spacingLg={10} spacingMd={5}>
        <Box py={5}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Header
                type="incident"
                reportTour="incident"
                buttonAction={buttonAction}
                isLoading={exporting}
                disabled={exporting}
              />
            </Grid>
            <Grid item xs={12}>
              <FormContext {...formMethods}>
                <IncidentReportFormat />
                <Box mt={2}>
                  <IncidentReportFilters />
                </Box>
              </FormContext>
            </Grid>
            <Grid item xs={12}>
              <ReportVersionTable
                refresher={refresher}
                currentReportVersion={currentReportVersion}
                setCurrentReportVersion={setCurrentReportVersion}
                kind={constants.reportVersions.KIND.INCIDENT}
              />
            </Grid>
          </Grid>
          <ReportVersionExistsDialog
            currentReportVersion={currentReportVersion}
            exportAction={exportReport}
            open={reportVersionExistsOpen}
            setCurrentReportVersion={setCurrentReportVersion}
            setOpen={setReportVersionExistsOpen}
          />
        </Box>
      </Container>
    </Page>
  )
}
export default IncidentsReports
